import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ErrorService} from '@app/services';
import {LanguageSearchParams} from '../language-search-params';
import {LanguageService} from '../language.service';
@Component({
  selector: 'hpf-language-count',
  templateUrl: './language-count.component.html'
})
export class LanguageCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: LanguageSearchParams = new LanguageSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private languageService: LanguageService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.languageService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
